import { POST } from '@wellsfargo/ecpfs-authority'

export const TERMS_OF_USE_PATH = 'login/footer/toc/text.json'

export function fetchTermsOfUse() {
	return POST(TERMS_OF_USE_PATH, {})
}
